import qs from 'qs';
import { SearchModes } from '../constants';

const decodeSearchObjFromQueryString = (
  query,
  destinationsAutocompleteResults,
  cruiseShipsAutocompleteResults,
  cruiseLinesAutocompleteResults,
  searchedMode,
) => {
  const searchObjectFromURL = qs.parse(query) || {};
  if (!Object.keys(searchObjectFromURL).length) {
    return {};
  }
  if (!searchedMode || searchedMode === SearchModes.CRUISE_TRIP) {
    const filteredLocations = (searchObjectFromURL.locations || []).map((locationItem) => {
      const [locationType, value] = locationItem.split(',');
      const location = destinationsAutocompleteResults.find((el) => el.value === locationType);
      const foundedLocation = location.suggests.find((el) => el.value === value);

      return {
        value: foundedLocation.value,
        label: foundedLocation.label,
        group: location.label,
        locationType: location.value,
      };
    });

    const cruiseLines = (
      (searchObjectFromURL.filters && searchObjectFromURL.filters.cruiseLines)
      || []
    ).map((value) => cruiseLinesAutocompleteResults[0].suggests.find((el) => el.value === value));

    const cruiseShips = (
      (searchObjectFromURL.filters && searchObjectFromURL.filters.cruiseShips)
      || []
    ).map((cruiseShip) => {
      const [locationType, value] = cruiseShip.split(',');
      const location = cruiseShipsAutocompleteResults.find((el) => el.value === locationType);
      const ship = location.suggests.find((el) => el.value === value);

      return {
        value: ship.value,
        label: ship.label,
        group: location.label,
        locationType: location.value,
      };
    });

    return {
      ...searchObjectFromURL,
      locations: filteredLocations,
      filters: { ...searchObjectFromURL.filters, cruiseShips, cruiseLines },
    };
  } if (searchedMode === SearchModes.FLIGHT && searchObjectFromURL.fs
    && searchObjectFromURL.fs.length) {
    searchObjectFromURL.flightSegments = searchObjectFromURL.fs;
    searchObjectFromURL.flightSearchType = Number(searchObjectFromURL.fst);
    delete searchObjectFromURL.fs;
    delete searchObjectFromURL.fst;
  }
  if (searchedMode === SearchModes.HOTEL && searchObjectFromURL.sa) {
    searchObjectFromURL.selectedAddress = { ...searchObjectFromURL.sa };
    if (searchObjectFromURL.selectedAddress.hotelId && !searchObjectFromURL.selectedAddress.value) {
      searchObjectFromURL.selectedAddress.value = searchObjectFromURL.selectedAddress.hotelId;
    }
    delete searchObjectFromURL.sa;
  }
  if (
    searchedMode === SearchModes.HOTEL
    && searchObjectFromURL.id
    && searchObjectFromURL.name
  ) {
    searchObjectFromURL.selectedAddress = {
      hotelId: searchObjectFromURL.id,
      value: searchObjectFromURL.id,
      label: searchObjectFromURL.name.replace(/-/g, ' '),
    };

    if (searchObjectFromURL.selectedAddress.hotelId && !searchObjectFromURL.selectedAddress.value) {
      searchObjectFromURL.selectedAddress.value = searchObjectFromURL.selectedAddress.hotelId;
    }

    // Delete `id` and `name` from `searchObjectFromURL`
    delete searchObjectFromURL.id;
    delete searchObjectFromURL.name;
  }

  return searchObjectFromURL;
};

export default decodeSearchObjFromQueryString;
